import {
    Box,
    Card,
    CardContent,
    Typography,
    Avatar,
    Divider,
    TextField,
    Button,
    Alert,
} from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

function EingabeKarte({ weight, reps, onWeight, onReps, onKeyDown, onCalc, error }) {
    return (
        <Card>
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Box display="flex" alignItems="center" mb={1.5}>
                    <Avatar sx={{ bgcolor: 'primary.dark', mr: 1, width: 32, height: 32 }}>
                        <FitnessCenterIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="subtitle2" color="text.primary">
                        1RM Rechner
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />

                <Box sx={{ display: 'flex', justifyContent: "-moz-initial", gap: 2, mb: 2 }}>
                    <TextField
                        label="Kg."
                        type="number"
                        inputProps={{ min: 0, step: 0.5 }}
                        placeholder="z.B. 100"
                        value={weight}
                        onChange={e => onWeight(e.target.value)}
                        onKeyDown={onKeyDown}
                        size="small"
                        fullWidth
                    />
                    <TextField
                        label="Wdh."
                        type="number"
                        inputProps={{ min: 1, max: 30, step: 1 }}
                        placeholder="z.B. 5"
                        value={reps}
                        onChange={e => onReps(e.target.value)}
                        onKeyDown={onKeyDown}
                        size="small"
                        fullWidth
                    />

                    <Button variant="contained" fullWidth onClick={onCalc}>
                        Berechnen
                    </Button>
                </Box>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
            </CardContent>
        </Card>
    );
}

export default EingabeKarte;
